import { Injectable } from '@angular/core';
import { Http, Headers } from "@angular/http";
import 'rxjs/Rx';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {ResGet} from "../res-get";
import { COMPOSITION_BUFFER_MODE } from '@angular/forms';


@Injectable()
export class ClientesService {

  CLnombre:string = "";
  CLcif:string = "";
  CLemail:string = "";
  CLtelefono:string = "";
  CLactivo:number=1;
  CLfechaultimoacceso="";
  
  
  //clientesURL:string = "https://app.solucionlegal.es/API/index.php/Clientes/clientesget/" + this.CLnombre + "/" + this.CLcif + "/" + this.CLemail + "/" + this.CLtelefono ;

  clientes:any[]=[];
  direcciones:any[]=[];
  clienteActual={};
  listaClientes=[];
  constructor( private http:HttpClient ) { }

  getClientes( filtro, pagina, ordenacion ){
      filtro.nombre==""?this.CLnombre="-":this.CLnombre=encodeURI(filtro.nombre);
      filtro.email==""?this.CLemail="-":this.CLemail=encodeURI(filtro.email);
      filtro.telefono==""?this.CLtelefono="-":this.CLtelefono=encodeURI(filtro.telefono);
      filtro.cif==""?this.CLcif="-":this.CLcif=encodeURI(filtro.cif);
      filtro.activo==true?this.CLactivo=1:this.CLactivo=0;
      filtro.ultimoacceso==""?this.CLfechaultimoacceso="-":this.CLfechaultimoacceso=filtro.ultimoacceso;
      
      
      let CLnombre=this.CLnombre;
      return this.http.post<ResGet>( `https://app.solucionlegal.es/API/index.php/Clientes/clientes/${this.CLcif}/${this.CLemail}/${this.CLtelefono}/${this.CLactivo}/${this.CLfechaultimoacceso}/${pagina}/${ordenacion.campo}/${ordenacion.orden}`, {CLnombre} )
                        .map( res=>{
                          
                          this.clientes=res.clientes;
                          return res;
                        });
  }

  insertCliente( cliente ){
    
    let body= JSON.stringify(cliente);
    
    return this.http.post( `https://app.solucionlegal.es/API/index.php/Clientes/createcliente`, body)
      .map( res=>{
        
        return res;
      });
  }

    updateCliente( cliente, codigo ){
      
      let body=JSON.stringify(cliente);
      return this.http.post(`https://app.solucionlegal.es/API/index.php/Clientes/updatecliente/${codigo}`, body)
        .map(res=>{
          return res;
        });
    }

    getCliente(codigo:any){
      return this.http.get<ResGet>(`https://app.solucionlegal.es/API/index.php/Clientes/cliente/${codigo}`)
                      .map(res=>{
                        
                        this.clienteActual=res["cliente"];
                        this.clienteActual["CLgestoria"]=parseInt(this.clienteActual["CLgestoria"]);
                        return this.clienteActual;
                      });
    }

    getNombresClientes(){
      return this.http.get(`https://app.solucionlegal.es/API/index.php/Clientes/nombresclientes`)
      .map(resp=>{
        this.listaClientes=resp["clientes"];
        return true;
      })
    }

    borrarCliente(codcliente){
      return this.http.delete(`https://app.solucionlegal.es/API/index.php/Clientes/cliente/${codcliente}`)
      .map(resp=>{
        return resp;
      });
    }

//DIRECCIONES
    getDirecciones(codigo:any){
      return this.http.get(`https://app.solucionlegal.es/API/index.php/Clientes/direcciones/${codigo}`)
      .map(resp=>{
        
        this.direcciones=resp["direcciones"];
        return this.direcciones;
      });
    }

    getDireccion(codigo:any){
      return this.http.get(`https://app.solucionlegal.es/API/index.php/Clientes/direccion/${codigo}`)
      .map(resp=>{
        
        return resp["direccion"];
      });
    }

    updateDireccion(direccion, codigo){
      let copy = Object.assign({}, direccion);
      delete copy.CLnombre;
      let body= JSON.stringify(copy);
      return this.http.post(`https://app.solucionlegal.es/API/index.php/Clientes/updatedireccion/${codigo}`,body)
      .map(res=>{
        
        return res;
      });
    }

    insertDireccion(direccion, codigo){
      direccion.CDcodcliente=codigo;
      let body=JSON.stringify(direccion);
      return this.http.post(`https://app.solucionlegal.es/API/index.php/Clientes/insertdireccion`,body)
      .map(res=>{
        
        return res;
      })
    }

    borrarDireccion(codDireccion){
      return this.http.delete(`https://app.solucionlegal.es/API/index.php/Clientes/Direccion/${codDireccion}`)
      .map(res=>{
        return res;
      });
    }

//ESTADO
    actualizarEstado(codigo){
      return this.http.get(`https://app.solucionlegal.es/API/index.php/Clientes/updateestado/${codigo}`)
      .map(resp=>{
        
        return resp;
      })
    }

//Guardar la nueva contraseña que elige un cliente cuando está en su perfil

    cambiarPass(cliente){
      let body=JSON.stringify(cliente);
      
      return this.http.post(`https://app.solucionlegal.es/API/index.php/Clientes/cambiarPass`, body)
      .map(resp=>{
        return resp;
      })
    }

    registrarClienteWeb(expediente){
      let body=JSON.stringify(expediente);

      return this.http.post(`https://app.solucionlegal.es/API/index.php/Clientes/registrarClienteWeb`, body)
      .map(resp=>{
        return resp;
      })
    }
  }




// WEBPACK FOOTER //
// ./src/app/services/clientes.service.ts